const error410 = {
  name: 'Erro 410',
  title: 'La página no está disponible',
  subtitle: '¡Qué pena! Este enlace ya no está disponible.',
};

export default error410;
